var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-outlook 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8369 15.6974L24.2969 13.0527V20.7821H29.3335V16.5614C29.3335 16.2054 29.1442 15.8767 28.8369 15.6974Z",
    fill: "#103262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.6665 6.66602H15.3332V12.666H8.6665V6.66602Z",
    fill: "#0084D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3335 6.66602H22.0002V12.666H15.3335V6.66602Z",
    fill: "#33AFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22 6.66602H28.6667V12.666H22V6.66602Z",
    fill: "#54DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3335 12.666H22.0002V18.666H15.3335V12.666Z",
    fill: "#027AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.3335 18.666H22.0002V24.666H15.3335V18.666Z",
    fill: "#0553A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22 12.666H28.6667V18.666H22V12.666Z",
    fill: "#25A2E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22 18.666H28.6667V24.666H22V18.666Z",
    fill: "#0262B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.019,
    d: "M8.6665 24.6662H28.6665V16.1582L19.3265 21.4915L8.6665 16.1582V24.6662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.038,
    d: "M8.6665 24.6657H28.6665V16.3164L19.3265 21.6497L8.6665 16.3164V24.6657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.057,
    d: "M8.6665 24.6672H28.6665V16.4766L19.3265 21.8099L8.6665 16.4766V24.6672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.076,
    d: "M8.6665 24.6668H28.6665V16.6348L19.3265 21.9681L8.6665 16.6348V24.6668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.095,
    d: "M8.6665 24.6663H28.6665V16.793L19.3265 22.1263L8.6665 16.793V24.6663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.114,
    d: "M8.6665 24.6671H28.6665V16.9531L19.3265 22.2865L8.6665 16.9531V24.6671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.133,
    d: "M8.6665 24.6667H28.6665V17.1113L19.3265 22.4447L8.6665 17.1113V24.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.152,
    d: "M8.6665 24.6662H28.6665V17.2695L19.3265 22.6029L8.6665 17.2695V24.6662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.171,
    d: "M8.6665 24.6657H28.6665V17.4277L19.3265 22.7611L8.6665 17.4277V24.6657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.191,
    d: "M8.6665 24.6672H28.6665V17.5879L19.3265 22.9212L8.6665 17.5879V24.6672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.209,
    d: "M8.6665 24.6668H28.6665V17.7461L19.3265 23.0794L8.6665 17.7461V24.6668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.229,
    d: "M8.6665 24.6663H28.6665V17.9043L19.3265 23.2376L8.6665 17.9043V24.6663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.248,
    d: "M8.6665 24.6658H28.6665V18.0625L19.3265 23.3958L8.6665 18.0625V24.6658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.267,
    d: "M8.6665 24.6673H28.6665V18.2227L19.3265 23.556L8.6665 18.2227V24.6673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.286,
    d: "M8.6665 24.6669H28.6665V18.3809L19.3265 23.7142L8.6665 18.3809V24.6669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    opacity: 0.305,
    d: "M8.6665 24.6657H28.6665V18.5391L19.3265 23.8724L8.6665 18.5391V24.6657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.324,
    d: "M8.6665 24.6672H28.6665V18.6992L19.3265 24.0326L8.6665 18.6992V24.6672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    opacity: 0.343,
    d: "M8.6665 24.6668H28.6665V18.8574L19.3265 24.1908L8.6665 18.8574V24.6668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.362,
    d: "M8.6665 24.6663H28.6665V19.0156L19.3265 24.349L8.6665 19.0156V24.6663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.381,
    d: "M8.6665 24.6658H28.6665V19.1738L19.3265 24.5072L8.6665 19.1738V24.6658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.4,
    d: "M8.6665 24.6673H28.6665V19.334L19.3265 24.6673L8.6665 19.334V24.6673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M10.2938 28.0005H28.0024C28.7384 28.0005 29.3351 27.4078 29.3358 26.6712C29.3378 23.6572 29.3331 16.5625 29.3331 16.5625C29.3331 16.5625 29.3284 16.7105 28.1658 17.3705C27.0031 18.0305 9.8291 27.7112 9.8291 27.7112C9.8291 27.7112 9.9851 28.0005 10.2938 28.0005Z",
    fill: "url(#paint0_linear_14084_12272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M28.6665 6.66667H8.6665V5.33333C8.6665 4.59667 9.26317 4 9.99984 4H27.3332C28.0698 4 28.6665 4.59667 28.6665 5.33333V6.66667Z",
    fill: "url(#paint1_linear_14084_12272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M8.6665 16.666V26.666C8.6665 27.4027 9.26317 27.9993 9.99984 27.9993H19.9998H28.0025C28.3105 27.9993 28.5912 27.8913 28.8165 27.716L8.6665 16.666Z",
    fill: "url(#paint2_linear_14084_12272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    opacity: 0.05,
    d: "M14.2125 8.66602H8.6665V24.666H14.2125C15.5678 24.666 16.6665 23.5673 16.6665 22.212V11.12C16.6665 9.76468 15.5678 8.66602 14.2125 8.66602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    opacity: 0.07,
    d: "M14.1418 24H8.6665V8.88867H14.1418C15.2912 8.88867 16.2225 9.82001 16.2225 10.9693V21.9193C16.2218 23.0687 15.2905 24 14.1418 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    opacity: 0.09,
    d: "M14.0705 23.3333H8.6665V9.11133H14.0705C15.0132 9.11133 15.7772 9.87533 15.7772 10.818V21.6267C15.7778 22.5693 15.0132 23.3333 14.0705 23.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M14 22.6673H3.33333C2.59667 22.6673 2 22.0707 2 21.334V10.6673C2 9.93065 2.59667 9.33398 3.33333 9.33398H14C14.7367 9.33398 15.3333 9.93065 15.3333 10.6673V21.334C15.3333 22.0707 14.7367 22.6673 14 22.6673Z",
    fill: "url(#paint3_linear_14084_12272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M8.66659 12.4609C6.59259 12.4609 5.34326 14.0456 5.34326 16.0003C5.34326 17.9549 6.58793 19.5396 8.66659 19.5396C10.7459 19.5396 11.9899 17.9549 11.9899 16.0009C11.9899 14.0456 10.7406 12.4609 8.66659 12.4609ZM8.66659 18.3449C7.48993 18.3449 6.7866 17.2956 6.7866 16.0009C6.7866 14.7063 7.49326 13.6569 8.66659 13.6569C9.83993 13.6569 10.5473 14.7069 10.5473 16.0009C10.5473 17.2949 9.8426 18.3449 8.66659 18.3449Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14084_12272",
    x1: 25.9498,
    y1: 16.3718,
    x2: 21.5238,
    y2: 24.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31ABEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1582D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14084_12272",
    x1: 9.10984,
    y1: 4.66133,
    x2: 27.5232,
    y2: 6.04933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#076DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0461AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14084_12272",
    x1: 18.7685,
    y1: 22.1447,
    x2: 15.7585,
    y2: 27.3993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33ACEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B8EDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14084_12272",
    x1: 2.35333,
    y1: 9.68732,
    x2: 14.94,
    y2: 22.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0864C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/outlook-icon.89b7e43015ae8749005aacd27cd093cd.svg";
export { ForwardRef as ReactComponent };